import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/base/BackToTop';
import JsonLd from '@/components/base/JsonLd';
import SectionHeading from '@/components/base/SectionHeading';
import HeroSection from './components/HeroSection';
import QuickTicker from './components/QuickTicker';
import LatestSection from './components/LatestSection';
import CategoryGrid from './components/CategoryGrid';
import HotRank from './components/HotRank';
import QuickTimeline from './components/QuickTimeline';
import FaqSection from './components/FaqSection';
import BrandSection from './components/BrandSection';
import { faqs, site } from '@/mocks/guagua';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: site.name,
    url: 'https://dfhov.cn/',
    description: site.intro,
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: site.name,
    url: 'https://dfhov.cn/',
    email: site.email,
    description: site.intro,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  },
];

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <JsonLd data={homeSchema} />
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <QuickTicker />
        <LatestSection />
        <CategoryGrid />
        <section className="px-4 md:px-6 py-12 md:py-16" aria-labelledby="home-rank">
          <div className="max-w-6xl mx-auto">
            <SectionHeading
              eyebrow="Trending Now"
              title="正在被讨论的那些事"
              desc="左边是阅读量最高的几篇，右边是刚刚发生、还没来得及细写的快讯。两边一起看，今天的全貌就差不多了。"
            />
            <h2 id="home-rank" className="sr-only">
              热议榜与快讯时间线
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
              <HotRank />
              <QuickTimeline />
            </div>
          </div>
        </section>
        <FaqSection />
        <BrandSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}